import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { get, set } from 'lodash';
import { useAxiosClient, useMutation } from '@lumahealthhq/ui-model';
export function useZendeskSSO() {
  var axiosClient = useAxiosClient();
  var fetchFn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(user) {
      var zendeskURL,
        agentSignIn,
        plusSplit,
        username,
        dirtyDomain,
        cleanDomain,
        _yield$axiosClient$po,
        data,
        token,
        redirectTo,
        redirect,
        _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            zendeskURL = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            if (!user.email.includes('@lumahealth.io')) {
              _context.next = 5;
              break;
            }
            agentSignIn = 'https://lumahealth.zendesk.com/access/normal';
            window.open(zendeskURL || agentSignIn, '_blank');
            return _context.abrupt("return", null);
          case 5:
            // if the email is in the format first+something@example.com
            // remove the +something so all tickets flow in to a single
            // login for the user
            if (user.email.includes('+')) {
              plusSplit = user.email.split('+');
              username = plusSplit[0];
              dirtyDomain = plusSplit[1];
              cleanDomain = dirtyDomain.split('@')[1];
              user.email = "".concat(username, "@").concat(cleanDomain); // eslint-disable-line
            }
            _context.next = 8;
            return axiosClient.post('/tokens/zendesk', user);
          case 8:
            _yield$axiosClient$po = _context.sent;
            data = _yield$axiosClient$po.data;
            token = data.token;
            redirectTo = zendeskURL || '';
            redirect = "https://lumahealth.zendesk.com/access/jwt?jwt=".concat(token, "&return_to=").concat(redirectTo);
            return _context.abrupt("return", redirect);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchFn(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var mutationResult = useMutation(['zendeskSSO'], function (_ref2) {
    var user = _ref2.user,
      zendeskURL = _ref2.zendeskURL;
    return fetchFn(user, zendeskURL);
  }, {
    onSuccess: function onSuccess(redirectUrl) {
      if (redirectUrl) {
        window.open(redirectUrl, '_blank');
      }
    },
    onError: function onError(err) {
      var error = get(err, 'response.data', {});
      var errorCode = get(error, 'code');
      if (errorCode === 422) {
        set(error, 'message', 'Missing email and/or name.');
      }
      throw error;
    }
  });
  return mutationResult;
}